// extracted by mini-css-extract-plugin
export default {"message":"Messager_message__pQr1U","success":"Messager_success__wj+PR","erro":"Messager_erro__mnKzB"};